<template>
    <div class="tela-final h-screen flex flex-col justify-center">


        <img class="responsive mx-auto" src="@/assets/images/novaintegracao/logo-wdc.svg" alt="">    

        <h1 class="sm:text-4xl md:text-6xl mt-4 vermelhowdc text-center font-black">Muito Obrigado {{userisloged.name}}!</h1>

        <div class="azulwdc text-center font-bold sm:text-lg md:text-2xl mx-auto" style="max-width:660px;">
            <p class="mt-8 md:mt-4">Estamos muito felizes de termos você na nossa Equipe!</p>
            <p class="md:mt-4" >Qualquer dúvidas sobre as informações aqui prestadas. Por favor contatar nosso rh por email. Mayara@wedocare.com.br</p>
        </div>
            
    </div>
</template>

<script>

    export default {
        name: "Produtos",
        props: [],
        created() {
          if (!this.userisloged){
            this.$router.push({name:'novaintegracao-login'})
          }
        },
        data() {
            return {
                pronome: 'a',
                animation_path: [],
                width: window.innerWidth,
            }
        },
        methods: {
            next(step) {
                this.$store.dispatch('integracao/setStep', step).then(() => {
                    this.$router.push({name: 'integracao-' + this.$store.state.integracao.page});
                })
            }
        }, watch: {
            windowWidth() {
                this.width = window.innerWidth;
            }
        },
        computed: {
            windowWidth() {
                return this.$store.state.windowWidth
            },
          userisloged(){
            let user = localStorage.getItem('integracaoLogged')
            return JSON.parse(user);
          }
        }
    }
</script>

<style scoped>
.tela-final{
    background-image: url('../../assets/images/novaintegracao/tela-final.png') !important;
    background-size: cover;
    background-repeat: no-repeat;

}
.tela-final img{
    max-width: 300px;
}

@media(max-width: 600px){
    .tela-final img{
    max-width: 150px;
}
}


</style>
